var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type"},[_c('div',{staticClass:"item",class:{active:_vm.value==='buy'},on:{"click":function($event){return _vm.change('buy')}}},[_c('span',[_vm._v("我购买的")])]),_c('div',{staticClass:"item",class:{active:_vm.value==='join'},on:{"click":function($event){return _vm.change('join')}}},[_vm._v(" 我加入的 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }